import { ABSENT_RULE, COST_RULE, CANCEL_RULE, CHARGE_REMINDER_TYPE } from 'data/constants'
import __R, {userCan} from 'containers/__R';

export default function getClassInfoFields() {
  const language = localStorage.getItem('language');
	return {
    date: {
      title: __('Date', 'class'),
      render: (opts) => {
        if(opts.data.startDateTime && opts.data.endDateTime){
          const startDate = opts.data.startDateTime.slice(0,10)
          const endDate = opts.data.endDateTime.slice(0,10)
          return opts.data.startDateTime && opts.data.endDateTime ? startDate + " – " + endDate : ''
        }
      }
    },
    classTeacherList: {
      title: __('Teacher', 'changeschool'),
      render: (opts) => {
        if(userCan(opts.data.cType == 0 ? 'read_class_teacher': 'read_private_class_teacher')){
          if(opts.data.classTeacherList){
            return opts.data.classTeacherList.map((teacher) => {
              return teacher.stName
            }).join(', ')
          }
        }
      }
    },
		studentList: {
			title: __('Student', 'schedule'),
      render: (opts) => {
        if (opts.data.classStudentList[0]) {
          let extraNotation = '';
          if (opts.data.classStudentList.length > 1) {
            extraNotation = ` (+${opts.data.classStudentList.length - 1})`;
          }
          return `${opts.data.classStudentList[0].ssName}${extraNotation}`;
        } else {
          return '';
        }
			}
		},
    total_lesson_amount: {
      title: __('Lesson Amount', 'class')
    },
    lessonCheckinedCount: {
      title: __('Past Lesson Counts', 'classdetail'),
      render: (opts) => {
        return opts.data.lessonCheckinedCount ? opts.data.lessonCheckinedCount: '0'
      }
    },
    payment_reminder: {
      title: __('Payment Reminder', 'classdetail'),
      render: (opts) => {
        let fieldValue;
        if(opts.data.feeType == 0) {
          fieldValue = language == 'CN'? '提前'+opts.data.costAlertRange +'天提醒' : opts.data.costAlertRange>1 ? opts.data.costAlertRange+' days in advance' : opts.data.costAlertRange+' day in advance';
        }else if(opts.data.feeType == 1) {
          fieldValue = language == 'CN'? '提前'+opts.data.costAlertRange +'节课提醒' : opts.data.costAlertRange>1 ? opts.data.costAlertRange+' lessons in advance' : opts.data.costAlertRange+' lesson in advance';
        }else {
          fieldValue = language == 'CN'? '提前'+opts.data.costAlertRange +'小时提醒' : opts.data.costAlertRange>1 ? opts.data.costAlertRange+' hours in advance' : opts.data.costAlertRange+' hour in advance';
        }
        return fieldValue;
      }
    },
    complettion_rule: {
      title: __('Lesson Completion Rules', 'createnewclass'),
      className:'col-sm-6',
      render: (opts) => {
        return COST_RULE[opts.data.costRule] + ', ' + ABSENT_RULE[opts.data.absentFlag] + ', ' + CANCEL_RULE[opts.data.cancelFlag];
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/containers/pages/ClassDetail/ClassInfoFields.js